import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { GeneralDTO, GeneralPatchDTO } from '../../interfaces/models';

const DEFAULT_GENERAL_POLICY: GeneralDTO = {
  id: 0,
  minimumProfitPercentage: 0,
  minimalSalePrice: 100,
  recommendedProfitPercentage: 0,
  serviceAbsoluteFee: 100,
  serviceAbsoluteFeeForCarrier: 100,
  inopAdditionalPricePercentage: 0,
  enclosedAdditionalPricePercentage: 0,
  creditCardPaymentFee: 4,
  achPaymentFee: 4,
};

@Injectable({ providedIn: 'root' })
export class GeneralService {

  policy: GeneralDTO = { ...DEFAULT_GENERAL_POLICY };

  constructor(protected httpClient: HttpClient) {
    this.generalCached$.subscribe();
  }

  generalCached$ = this.get().pipe(
    tap((policy) => {
      this.policy = {
        ...DEFAULT_GENERAL_POLICY,
        ...policy,
      };
    }),
    catchError(() => of(this.policy)),
    shareReplay(1),
  );

  public get(): Observable<GeneralDTO> {
    return this.httpClient.get<GeneralDTO>(`${environment.api}/general`);
  }

  public update(data: GeneralPatchDTO): Observable<GeneralDTO> {
    return this.httpClient.patch<GeneralDTO>(`${environment.api}/general`, data);
  }
}
